import { baseClasses } from '@weatherbug/common';
import { LocationProvider } from '../providers/locationProvider';

const { AsyncAction } = baseClasses;

export const SET_ACTIVE_LOCATION = new AsyncAction('SET_ACTIVE_LOCATION');
export const SET_INITIAL_ACTIVE_LOCATION = 'SET_INITIAL_ACTIVE_LOCATION';
export const GET_RECENT_SEARCH_LOCATIONS = new AsyncAction('GET_RECENT_SEARCH_LOCATIONS');
export const CREATE_RECENT_SEARCH_LOCATION = new AsyncAction('CREATE_RECENT_SEARCH_LOCATION');

export function switchLocation(location) {
    return async (dispatch, getState) => {
        const currState = getState();
        const recentSearchLocationPosition = currState?.location?.recentSearchLocations?.length || 0; // we need to decide on this, seems odd that values comes super late for some reason, can't rely on appstate here.
        let user;

        const userSearchLocation = {
            Location: {
                Locality: location?.Locality
            },
            Position: recentSearchLocationPosition
        };

        try {
            await dispatch(createRecentSearchLocation(userSearchLocation));
            user = currState?.appState?.appState?.user;
        } catch (error) {
            console.log('Error creating recent search location', error);
        } finally {
            // ensure to use data that has both Station data and Locality data and Default Route string values to prevent weird behaviour in app.
            const newActiveLocation  = user?.ActiveLocation?.Locality?.CityId === location?.CityId ? user?.ActiveLocation : location;
            await dispatch(setActiveLocation(newActiveLocation));
        }
    };
}

export function setActiveLocation(location) {
    return {
        type: SET_ACTIVE_LOCATION.base,
        payload: setActiveLocationAction(location)
    };
}

async function setActiveLocationAction(location) {
    const op = new LocationProvider();
    return await op.setActiveLocation(location);
}

export function setInitialActiveLocation(location) {
    return {
        type: SET_INITIAL_ACTIVE_LOCATION,
        payload: location
    };
}

export function getRecentSearchLocations() {
    return {
        type: GET_RECENT_SEARCH_LOCATIONS.base,
        payload: getRecentSearchLocationsAction()
    };
}

async function getRecentSearchLocationsAction() {
    const op = new LocationProvider();
    return await op.getRecentSearchLocations();
}

export function createRecentSearchLocation(location) {
    return {
        type: CREATE_RECENT_SEARCH_LOCATION.base,
        payload: createRecentSearchLocationsAction(location)
    };
}

async function createRecentSearchLocationsAction(location) {
    const op = new LocationProvider();
    return await op.createRecentSearchLocation(location);
}
